import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import SwiperClass from "swiper";
import ButtonBack from "../../common/carousel/ButtonBack";
import ButtonNext from "../../common/carousel/ButtonNext";
import Carousel from "../../common/carousel/Carousel";
import { useIsMD } from "../../../utils/hooks/useWindowSizes";
import { TBreackpointsCarousel } from "../../../models/common/common";

const OvernightCarousel: FC<{
    visibleCards: ReactNode[];
    resetCarousel: boolean;
    setResetCarousel: (el: boolean) => void;
}> = ({ visibleCards, resetCarousel, setResetCarousel }) => {
    const [swiperClass, setSwiperClass] = useState<SwiperClass | null>(null);

    useEffect(() => {
        if (resetCarousel) {
            setResetCarousel(false);
        }
    }, [visibleCards]);

    const isMD = useIsMD();

    const length = useMemo(() => visibleCards.length, [visibleCards]);

    const breackPointCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: 1.3,
            height: 533,
            spaceBetween: 12,
        },
        576: {
            slidesPerView: 2,
            height: 533,
            spaceBetween: 12,
        },
        768: {
            slidesPerView: 2.5,
            height: 533,
            spaceBetween: 12,
        },
        992: {
            slidesPerView: 3,
            height: 533,
            spaceBetween: 12,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
        1600: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
        1920: {
            slidesPerView: 5,
            spaceBetween: 32,
        },
    };

    return (
        <MDBRow className="py-2 mx-2 mt-5 mt-md-2 justify-content-center">
            {!isMD && length > 3 && (
                <MDBCol center size={1}>
                    <ButtonBack swiperClass={swiperClass} />
                </MDBCol>
            )}
            <MDBCol size={12} lg={10}>
                {length > 0 ? (
                    <Carousel
                        setSwiperClass={setSwiperClass}
                        visibleSlides={3}
                        breakpoints={breackPointCarousel}
                    >
                        {visibleCards}
                    </Carousel>
                ) : (
                    ""
                )}
            </MDBCol>
            {!isMD && length > 3 && (
                <MDBCol center size={1}>
                    <ButtonNext swiperClass={swiperClass} />
                </MDBCol>
            )}
        </MDBRow>
    );
};

export default OvernightCarousel;
